import { useState } from "react";
import styled from "styled-components";
import { CheckmarkIconSmall } from "../atoms/icons/CheckmarkIcons";
import { SourceCodeIcon } from "../atoms/icons/SourceCodeIcon";
import { theme } from "../../theme";
import BodySmall from "../atoms/typography/BodySmall";
import Small from "../atoms/typography/Small";

interface Props {
  copyValue: string;
  textValue?: string;
  variant?: "normal" | "discrete";
}

const Container = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CopyForDebuggingButton: React.FC<Props> = ({
  copyValue,
  textValue,
  variant = "normal",
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (event: React.MouseEvent) => {
    event.stopPropagation();
    navigator.clipboard.writeText(copyValue);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Container onClick={handleCopy}>
      {textValue && variant === "normal" ? (
        <BodySmall>{textValue}</BodySmall>
      ) : variant === "discrete" ? (
        <Small color={theme.colors.textMuted}>{textValue}</Small>
      ) : null}
      {copied ? (
        <CheckmarkIconSmall color={theme.colors.textMuted} />
      ) : (
        <SourceCodeIcon color={theme.colors.textMuted} />
      )}
    </Container>
  );
};

export default CopyForDebuggingButton;
